import {
  OperationGuide,
  SystemInfo,
  NotificationParams,
  NotificationResultModel,
} from './model/systemModel';
import { defHttp } from '/@/utils/http/axios';

export enum SysApi {
  // 系统维护查询
  inMaintenance = '/member/maintenance',
  // 获取操作指南
  getOperationGuide = '/member/docs',
  // 获取会员操作指南
  getMemberOperationGuide = '/ex-member/docs',
  // 系统通知订阅
  subscribe = '/common/notification/subscribe',
  // 系统通知取消订阅
  unsubscribe = '/common/notification/subscribe/close',
  // 确认通知
  confirm = '/common/notification/confirm',
  // 获取通知列表
  getNotificationList = '/common/notification/search',
  // ip是否为中国大陆境内Ip
  isChinaMainland = '/adapter/ip/china-mainland',
}

/**
 * [查询系统维护状态等信息](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E7%BB%B4%E6%8A%A4%E4%BF%A1%E6%81%AF/inMaintenance)
 * @returns 系统状态信息
 */
export function fetchSystemInfo() {
  return defHttp.get<SystemInfo>({ url: SysApi.inMaintenance });
}

/**
 * [获取操作指南](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E9%9D%99%E6%80%81%E6%96%87%E4%BB%B6/listAllDocs)
 */
export function fetchOperationGuide() {
  return defHttp.get<OperationGuide[]>({ url: SysApi.getOperationGuide });
}

/**
 * [获取会员操作指南](https://mtex-dev1.microconnect.cc/ex-member/doc.html#/-ex-member-v3-api-docs/%E9%9D%99%E6%80%81%E6%96%87%E4%BB%B6/listAllDocs)
 */
export function fetchMemberOperationGuide() {
  return defHttp.get<OperationGuide[]>({ url: SysApi.getMemberOperationGuide });
}

// 获取通知列表
export function getNotificationList(params: NotificationParams) {
  return defHttp.post<NotificationResultModel>({ url: SysApi.getNotificationList, params });
}

// 确认通知
export function confirmNotification(params) {
  return defHttp.post({ url: SysApi.confirm, params });
}

/**
 * [是否为大陆境内ip](https://exmt-dev1-api.microconnect.cc/adapter/doc.html#/-adapter-v3-api-docs/IP%E4%BF%A1%E6%81%AF/isChinaMainland)
 */
export function isChinaMainland() {
  return defHttp.get({ url: SysApi.isChinaMainland });
}
